import { useEffect } from 'react';
import { oneOfType, number, string } from 'prop-types';
import { useLocation } from 'react-router-dom';

/**
 * A single-page app keeps the scroll position across navigations, so opening
 * a topic from halfway down a list would start you halfway down the topic.
 */
const scrollToTop = () => {
  window.scrollTo(0, 0);
  // The dashboard scrolls an inner element, not the window.
  document.querySelector('.gx-main-content-wrapper')?.scrollIntoView();
};

/** Mounted once inside the router: resets on every navigation. */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(scrollToTop, [pathname]);
  return null;
};

/**
 * For places that change what is displayed without changing the URL — the
 * reader moves between topics in the same route.
 */
export const ScrollToWithProps = ({ change }) => {
  useEffect(scrollToTop, [change]);
  return null;
};

ScrollToWithProps.propTypes = { change: oneOfType([string, number]) };

export default ScrollToTop;
